var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loan-detail"}},[_c('vx-card',[_c('h6',{staticClass:"success bold"},[_vm._v("Crédito")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }